import type { ImpactRow } from './types'
import { displayAnswer, toServiceTone } from './utils'

function SelectedImpactHeader({
    selectedImpact,
}: {
    selectedImpact: ImpactRow
}) {
    return (
        <div>
            <p className='text-foreground font-semibold'>
                {selectedImpact.item.itemNumber
                    ? `${selectedImpact.item.itemNumber}. `
                    : ''}
                {selectedImpact.item.title}
            </p>
            <p className='text-muted-foreground mt-1 text-xs'>
                {selectedImpact.item.part} ·{' '}
                {selectedImpact.item.majorCategory ?? '-'}
            </p>
        </div>
    )
}

function ScoreBox({ selectedImpact }: { selectedImpact: ImpactRow }) {
    return (
        <div className='border-border rounded-sm border p-3'>
            <p className='text-muted-foreground text-xs'>현재 점수</p>
            <p className='text-foreground mt-1 font-semibold'>
                {selectedImpact.score
                    ? `${selectedImpact.score.score ?? 0}/${selectedImpact.score.maxScore}점`
                    : '채점 전'}
            </p>
        </div>
    )
}

function AnswerBox({ selectedImpact }: { selectedImpact: ImpactRow }) {
    return (
        <div className='border-border rounded-sm border p-3'>
            <p className='text-muted-foreground text-xs'>내가 답한 내용</p>
            {selectedImpact.item.fields.length > 0 ? (
                <ul className='mt-2 grid gap-1'>
                    {selectedImpact.item.fields.map((field) => {
                        const answer = selectedImpact.answers.find(
                            (item) => item.fieldId === field.fieldId
                        )
                        return (
                            <li
                                key={field.fieldId}
                                className='text-muted-foreground'>
                                <span className='text-foreground font-medium'>
                                    {field.nameKo}:
                                </span>{' '}
                                {displayAnswer(answer)}
                            </li>
                        )
                    })}
                </ul>
            ) : (
                <p className='text-muted-foreground mt-1'>
                    항목 단위 답변입니다.
                </p>
            )}
        </div>
    )
}

function ImpactChangeBox({ selectedImpact }: { selectedImpact: ImpactRow }) {
    if (!selectedImpact.affected) return null

    return (
        <div className='border-border rounded-sm border p-3'>
            <p className='text-muted-foreground text-xs'>변경 영향</p>
            <p className='text-foreground mt-1'>
                {toServiceTone(
                    selectedImpact.affected.expected_change ??
                        selectedImpact.affected.recommendation ??
                        '재점검이 필요합니다.'
                )}
            </p>
        </div>
    )
}

/** 선택한 영향 항목의 상세 정보 블록을 표시한다. */
export function SelectedImpactDetails({
    selectedImpact,
}: {
    selectedImpact: ImpactRow
}) {
    return (
        <div className='grid gap-3 text-sm'>
            <SelectedImpactHeader selectedImpact={selectedImpact} />
            <ScoreBox selectedImpact={selectedImpact} />
            <AnswerBox selectedImpact={selectedImpact} />
            <ImpactChangeBox selectedImpact={selectedImpact} />
        </div>
    )
}
